module.exports = __webpack_public_path__ + "assets/img/IMG010.6b2c423d.png";